// @mui
import Tooltip from '@mui/material/Tooltip';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import IconButton from '@mui/material/IconButton';
// routes
import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';
// components
import { Iconify } from 'src/components/iconify';
// locales
import { useLocales } from 'src/locales';
// types
import { ITableTextItem } from 'src/types/table-text';

type Props = {
  row: ITableTextItem;
};

export default function TableTextTableRow({ row }: Props) {
  const { t } = useLocales('tableTextPage');
  const { key, name } = row;

  const title = name || row.key || t('noTitle');

  return (
    <TableRow hover>
      <TableCell
        sx={{
          whiteSpace: 'nowrap',
        }}
      >
        {title}
      </TableCell>

      <TableCell align="right" sx={{ px: 1, whiteSpace: 'nowrap' }}>
        <Tooltip title={`${t('edit')} ${t('text')}`} placement="top" arrow>
          <IconButton
            component={RouterLink}
            href={`${paths.admin.dashboard.table_text}/${key}/edit`}
          >
            <Iconify icon="solar:pen-bold" />
          </IconButton>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
}
